import simg1 from '../images/service/1.svg'
import simg2 from '../images/service/2.svg'
import simg3 from '../images/service/3.svg'
import simg4 from '../images/service/4.svg'

import sSimg1 from '../images/service-single/img1.jpg'
import sSimg2 from '../images/service-single/img2.jpg'
import sSimg3 from '../images/service-single/img3.jpg'
import sSimg4 from '../images/service-single/img4.jpg'



const Services = [
   {
      Id: '01',
      sImg: simg1,
      sSImg: sSimg1,
      title: 'Free Surgeries ',
      slug: '1',
      description: ' Free heart surgeries cover 100% of costs for children',
   },
   {
      Id: '02',
      sImg: simg2,
      sSImg: sSimg2,
      title: 'Complete Treatment',
      slug: '2',
      description: 'full care ensures complete recovery and a healthy life.',
   },
   {
      Id: '03',
      sImg: simg3,
      sSImg: sSimg3,
      title: 'Expert Partnership',
      slug: '3',
      description: 'Collaborating with local professionals',
   },
   {
      Id: '04',
      sImg: simg4,
      sSImg: sSimg4,
      title: 'Global Reach',
      slug: '4',
      description: 'reach thousands of children denied life-saving care',
   },

]

export default Services;